<div class="optimised-sequence px-3 pt-2 pb-3">
    @if(!isSuccessOptimisation && !isLoading) {
        <div class="error-message py-2 my-2">
            <span class="text-break"><b>Optimisation Failed :</b> {{errorMessage}} </span>
        </div>
    }
    <p-table [value]="optimisedSequence" [rowHover]="true" [loading]="isLoading"
        [scrollable]="true" scrollHeight="flex" scrollHeight="400px" [style]="{'height': '100%'}" appendTo="body">
        <ng-template pTemplate="loadingicon">
            <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
                <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
            </svg>
        </ng-template>
        
        <ng-template pTemplate="header">
            <tr class="header-top-row">
                <th colspan="3" scope="colgroup" class="empty-header" style="min-width: 160px;"></th>
                <th colspan="2" scope="colgroup" 
                 [ngClass]="{'optimised-sequence-badge-cell': true, 'badge-error': hasSomeError, 'badge-success': !hasSomeError}"
                 style="min-width: 212px;">
                    <span class="badge" >Optimized sequence</span>
                </th>
                <th colspan="5" scope="colgroup"  style="min-width: 510px;">
                    <div class="route-stats-cell">
                        <span class="stat-item">
                            <span class="stat-label">Drive time</span>
                            <span class="stat-values">
                                <span class="stat-value">{{driveTimeBefore}} hr</span>
                                <i class="pi pi-arrow-right stat-arrow"></i>
                                <span class="stat-value" [ngClass]="driveTimeStatus">{{driveTimeAfter}} hr</span>
                                @if (driveTimeStatus === 'pn-danger') { <i class="pi pi-arrow-up pn-danger stat-icon"></i> }
                                @if (driveTimeStatus === 'pn-success') { <i class="pi pi-arrow-down pn-success stat-icon"></i> }
                            </span>
                        </span>
                        <span class="stat-item">
                            <span class="stat-label">Drive Distance</span>
                            <span class="stat-values">
                                <span class="stat-value">{{driverDistanceBefore}} km</span>
                                <i class="pi pi-arrow-right stat-arrow"></i>
                                <span class="stat-value" [ngClass]="driverDistanceStatus">{{driverDistanceAfter}} km</span>
                                @if (driverDistanceStatus === 'pn-danger') { <i class="pi pi-arrow-up pn-danger stat-icon"></i> }
                                @if (driverDistanceStatus === 'pn-success') { <i class="pi pi-arrow-down pn-success stat-icon"></i> }
                            </span>
                        </span>
                        <span class="stat-item">
                            <span class="stat-label">Total Time</span>
                            <span class="stat-values">
                                <span class="stat-value">{{totalTimeBefore}} hr</span>
                                <i class="pi pi-arrow-right stat-arrow"></i>
                                <span class="stat-value" [ngClass]="totalTimeStatus">{{totalTimeAfter}} hr</span>
                                @if (totalTimeStatus === 'pn-danger') { <i class="pi pi-arrow-up pn-danger stat-icon"></i> }
                                @if (totalTimeStatus === 'pn-success') { <i class="pi pi-arrow-down pn-success stat-icon"></i> }
                            </span>
                        </span>
                    </div>
                </th>
            </tr>
            <tr>
                <th style="width: 5% !important;"></th>
                @for (column of optimisedSequenceColumns; track column.field) {
                    <th  [pSortableColumn]="column.field" scope="col" [style.width]="column.width"> {{column.header}} <p-sortIcon [field]="column.field" /></th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-rowData="rowData">
            <tr>
                <td>
                    @if(data.error) {
                        <i class="pi pi-exclamation-triangle" style="color: #9B1C2E;" appendTo="body" [pTooltip]="data.error" autoHide="false" ></i>
                    }
                </td>
                @for (column of optimisedSequenceColumns; track column.field) {
                    @if(column.field !== 'new_task_sequence' && column.field !== 'new_stop_sequence' && column.field !== 'time_window') {
                        <td [style.min-width]="column.width" style="display: table-cell;"> {{ data[column.field] }} </td>
                    }
                    @if(column.field === 'new_task_sequence') {
                        <td [style.min-width]="column.width" 
                        [ngStyle]="{'background-color': data.error ? '#F8D7DA' : data.taskSequenceChanged ? '#E1EFD8' : 'transparent' }"
                        style="display: table-cell; opacity: 0.7;"> {{ data[column.field] }} </td>
                    }
                    @if(column.field === 'new_stop_sequence') {
                        <td [style.min-width]="column.width" 
                        [ngStyle]="{'background-color':  data.error ? '#F8D7DA' : data.stopSequenceChanged ? '#E1EFD8' : 'transparent' }"
                        style="display: table-cell; opacity: 0.7;"> {{ data[column.field] }} </td>
                    }
                    @if(column.field === 'time_window') {
                        <td [style.min-width]="column.width" 
                        [ngStyle]="{'background-color':  data.error ? '#F8D7DA' : data.stopSequenceChanged ? '#E1EFD8' : 'transparent' }"
                        style="display: table-cell; opacity: 0.7;"> {{ data[column.field] }} </td>
                    }
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td  [attr.colspan]="optimisedSequenceColumns.length + 1">
                    <div class="text-center no-record-label">No Records found.</div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<ng-template #optimisedSequenceFooter>
    <div class="optimised-footer">
        <p>Do you want to apply it ?  <b>{{timerDisplay}}</b> Sec</p>
        <button class="pn-button pn-button-primary pn-button-md me-1" (click)="getOptimisedSequence()" [disabled]="!timerExpired ||isLoading">Re-optimize </button>
        <button class="pn-button pn-button-primary pn-button-md me-1" (click)="acceptOptimisation()" [disabled]="timerExpired || isLoading">Accept </button>
        <button class="pn-button pn-button-tertiary pn-button-md me-2" (click)="rejectOptimisation()" [disabled]="timerExpired || isLoading">Reject</button>
    </div>
</ng-template>